// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1YLsg","title":"Header_title__2QLkn","side":"Header_side__3ZjcR"};